import InvitePage from 'Components/Pages/Invite/InvitePage'
import OrderHistoryPage from 'Components/Pages/OrderHistory/OrderHistoryPage'
import SubscriptionsPage from 'Components/Pages/Subscriptions/SubscriptionsPage'
import UserAccount from 'Components/Pages/UserAccount'
import PersonalDetailsWrapper from 'Components/Elements/Settings/Wrapper'
import GenealogyPage from 'Components/Pages/Genealogy/GenealogyPage'
import AchievementsPage from 'Components/Pages/Achievements/AchievementsPage'

export const UserAccoutRoutes = {
    path: 'user',
    element: <UserAccount />,
    children: [
        {
            path: 'orderhistory',
            element: <OrderHistoryPage />
            // children: [
            //     {
            //         path: ':order_id',
            //         element: <OrderHistoryPage />
            //     }
            // ]
        },
        {
            path: 'orderhistory/:order_id',
            element: <OrderHistoryPage />
        },
        {
            path: 'subscriptions/*',
            element: <SubscriptionsPage />
        },
        {
            path: 'invite',
            element: <InvitePage />
        },
        {
            path: 'settings/*',
            element: <PersonalDetailsWrapper />
        },
        {
            path: 'genealogy',
            element: <GenealogyPage />
        },
        {
            path: 'genealogy/:customerId/:customerHref',
            element: <GenealogyPage />
        },
        {
            path: 'genealogy/:customerId',
            element: <GenealogyPage />
        },
        {
            path: 'achievements',
            element: <AchievementsPage />
        }
    ]
}
